/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import React from 'react';

import ReportTableContainer from 'reports/Common/ReportTable';
import {
  calculateWorkingHoursByCategory,
  calculateWorkingHoursByService,
  convertHoursByCategoryOrServiceDataToTable,
} from 'reports/utils';

class SalonHoursWorkedByCategoryOrServiceTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let tableData;
    if (this.props.type === 'Category') {
      tableData = {
        rows: convertHoursByCategoryOrServiceDataToTable(
          calculateWorkingHoursByCategory(this.props.data),
          this.props.type,
        ),
      };
    } else {
      tableData = {
        rows: convertHoursByCategoryOrServiceDataToTable(
          calculateWorkingHoursByService(this.props.data),
          this.props.type,
        ),
      };
    }
    return (
      <div id="salon-hours-worked-by-type">
        <ReportTableContainer
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          title={`Hours worked by ${this.props.type}`}
          data={tableData}
        />
        <br /> <br /> <br />
      </div>
    );
  }
}

export default SalonHoursWorkedByCategoryOrServiceTable;
